module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "front"
  }, [_c('md-card', [_c('md-card-content', {
    staticClass: "single"
  }, [_c('md-card', {
    staticClass: "card",
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('div', {
    staticClass: "copy"
  }, [_c('p', [_vm._v("The course has a number of chapters. If it’s the first time you go through the course it may be advisable for you to follow the schedule proposed here.")]), _vm._v(" "), _c('p', [_vm._v("If you have already completed the course please select any chapter required by clicking on it. You can return to it any time.\n                ")]), _c('p', [_vm._v("The pump can be set up in many ways but you will always follow your local policy and procedures first. ")]), _vm._v("\n                Make sure you are well informed about your local policy and procedure before operating the pump."), _c('p'), _vm._v(" "), _c('p', [_vm._v("To be set up in the seven main areas in the same manner as aic. ")])]), _vm._v(" "), _c('md-list', {
    staticClass: "nav"
  }, [_c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-1"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/1.svg"),
      "alt": "Module 1"
    }
  })]), _c('p', [_vm._v("Module 1")]), _c('span', [_vm._v("Features")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(2)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-2"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/2.svg"),
      "alt": "Module 2"
    }
  })]), _c('p', [_vm._v("Module 2")]), _c('span', [_vm._v("Modes of operation")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(3)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-3"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/3.svg"),
      "alt": "Module 3"
    }
  })]), _c('p', [_vm._v("Module 3")]), _c('span', [_vm._v("Alarms & Trouble Shooting")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(4)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-4"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/4.svg"),
      "alt": "Module 4"
    }
  })]), _c('p', [_vm._v("Module 4")]), _c('span', [_vm._v("Care & Maintenance")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(5)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-5"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/5.svg"),
      "alt": "Module 5"
    }
  })]), _c('p', [_vm._v("Module 5")]), _c('span', [_vm._v("Accessories")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(6)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-6"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/6.svg"),
      "alt": "Module 1"
    }
  })]), _c('p', [_vm._v("Module 6")]), _c('span', [_vm._v("Additional Features")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(7)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-7"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/7.svg"),
      "alt": "Module 7"
    }
  })]), _c('p', [_vm._v("Module 7")]), _c('span', [_vm._v("Course Summary & Assessment")])])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "progress"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f21a4b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front.vue
// module id = 747
// module chunks = 0